import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {ECRoutesNames} from '@/app/client/router/enums';
import {ESettingsFrontType} from '@/config/enums';

export const clientPageRoutes: Array<RouteRecordRaw> = [
  {
    path: '/subscriptions',
    name: ECRoutesNames.CSubscriptionsPage,
    meta: {
      access_mode: [ESettingsFrontType.ADMIN, ESettingsFrontType.CLIENT],
      access_roles: [ERoleSystem.ADMIN, ERoleSystem.USER],
    },
    component: () => import('@/app/client/pages/CSubscriptionsPage.vue'),
  },
  {
    path: '/notifications',
    name: ECRoutesNames.CNotificationsPage,
    meta: {
      access_mode: [ESettingsFrontType.ADMIN, ESettingsFrontType.CLIENT],
      access_roles: [ERoleSystem.ADMIN, ERoleSystem.USER],
    },
    component: () => import('@/app/client/pages/CNotificationsPage.vue'),
  },
];
